// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"43afb820","328":"fbdb7cb6","439":"2828f54d","476":"43afb820","508":"b49deb63","543":"3807d0e9","623":"223640db","663":"ac78fbf2","949":"510d9d11"}[chunkId] + ".chunk.css";
};